<template>
	<v-container fluid class="crm-index">
		<!-- <div class="d-flex align-center justify-end mb-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.companies.companyProjectDestiniesCount"
				:loading-info="$store.state.companies.companyProjectDestiniesLoading"
			/>
		</div> -->
		<v-data-table
			ref="table"
			:headers="headers"
      :items="$store.state.companies.companyProjectDestinies"
			item-key="id"
      :loading="$store.state.companies.companyProjectDestiniesLoading"
			:server-items-length="$store.state.companies.companyProjectDestiniesCount"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página',
				'items-per-page-options': itemsPerPageOptions
			}"
		>
      <template v-slot:body="{ items }">
        <draggable
          v-model="$store.state.companies.companyProjectDestinies"
					tag="tbody"
          item-key="id"
          @end="startEndDragEvent"
        >
					<tr v-for="(item) in items" :key="item.id" style="cursor: pointer;" :class="selectedRowClass(item)" @click="selectRow(item)">
						<td>
							<div class="d-flex align-center">
								<v-icon style="cursor: pointer;">mdi-unfold-more-horizontal</v-icon>
								<p class="ml-2 mb-0">{{ item.name }}</p>
							</div>
						</td>
						<td>
							<v-tooltip bottom v-if="$store.state.user.userInfo">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="warning"
										class="mx-1"
										@click.stop="() => { selectRow(item); editCompany(item); }"
										v-bind="attrs"
										v-on="on"
										v-if="$checkPermissions(['edit_company'])"
									>
										<v-icon small dark>mdi-pencil</v-icon>
									</v-btn>
								</template>
								<span>Editar</span>
							</v-tooltip>
							<v-tooltip bottom v-if="$store.state.user.userInfo">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
														icon
										dark
										x-small
										color="error"
										class="mx-1"
										v-if="$checkPermissions(['delete_company'])"
										@click.stop="() => { selectRow(item); deleteDestiny(item.id); }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-delete-outline</v-icon>
									</v-btn>
								</template>
								<span>Eliminar</span>
							</v-tooltip>
						</td>
					</tr>
				</draggable>
			</template>
      <!-- <template v-slot:item.name="{ item }">
				<div class="d-flex align-center">
					<p class="ml-2 mb-0">{{ item.name }}</p>
				</div>
      </template>
      <template v-slot:item.actions="{ item }">
				<v-tooltip bottom v-if="$store.state.user.userInfo">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="warning"
							class="mx-1"
							@click.stop="() => { selectRow(item); editCompany(item); }"
							v-bind="attrs"
							v-on="on"
							v-if="$checkPermissions(['edit_company'])"
						>
							<v-icon small dark>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span>Editar</span>
				</v-tooltip>
				<v-tooltip bottom v-if="$store.state.user.userInfo">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
											icon
							dark
							x-small
							color="error"
							class="mx-1"
							v-if="$checkPermissions(['delete_company'])"
							@click.stop="() => { selectRow(item); deleteDestiny(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-delete-outline</v-icon>
						</v-btn>
					</template>
					<span>Eliminar</span>
				</v-tooltip>
      </template> -->
    </v-data-table>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.companies.companyProjectDestiniesCount"
				:loading-info="$store.state.companies.companyProjectDestiniesLoading"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import {deleteCompanyProjectDestiny, updateCompanyProjectDestinyOrders} from '@/helpers/api/company'
// import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import draggable from "vuedraggable"

export default {
	name: 'ProjectDestinies',
	components: {
		// DataTablePagination,
		draggable
	},
  data() {
    return {
      search: '',
			selectedRowItem: null,
			searchInput: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 500,
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        { text: 'Destino', value: 'name' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
  },
	mounted(){
		const selectedRow = JSON.parse(localStorage.getItem('selected_companieslist_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		this.reloadInfo()
	},
  methods: {
		startEndDragEvent: _debounce(function(ev){ this.endDragEvent(ev) }, 800),
		async endDragEvent(ev){
			console.log(ev)
			if (typeof ev.newIndex === 'number') {
				const project_destinies = this.$store.state.companies.companyProjectDestinies.map((project_destiny, index) => {
					return { order: index + 1, id: project_destiny.id}
				})
				await updateCompanyProjectDestinyOrders({project_destinies})
				this.reloadInfo()
			}
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_companieslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('companies/getCompanyProjectDestinies', data)
		},
		showDeleteCompany(company){
			if(this.$store.state.user.userInfo){
				return company.company.responsible == this.$store.state.user.userInfo.id
			}
			return false
		},
    editCompany(destiny) {
			const data = {
				company_project_destiny_id: destiny.id,
				name: destiny.name,
			}
			this.$store.commit('companies/setNewDestinyModalEditing', data)
			this.$store.commit('companies/setNewDestinyModal', true)
    },
    async deleteDestiny(company_project_destiny_id) {
      await deleteCompanyProjectDestiny({company_project_destiny_id})
			this.reloadInfo()
    }
  },
};
</script>

<style scoped>
</style>